
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class Link extends Vue {
  @Prop() to?: string;
  @Prop() href?: string;
}
